import axios from 'axios';
import store from './store';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const baseApiUrl = process.env.VUE_APP_API_URL;

const axiosConfig = {
  baseURL: baseApiUrl,
  timeout: 30000,
  withCredentials: false,
  credentials: 'same-origin',
  cors: true,
  headers: {},
};

const api = ({ auth = null, headers = null } = {}) => {
  axiosConfig.auth = auth || null;
  const apiToken = store.state.auth.token;

  // Copy any additional headers passed with the api method request
  if (headers) {
    Object.assign(axiosConfig.headers, headers);
  }

  if (apiToken) {
    axiosConfig.headers.Authorization = `Bearer ${apiToken}`;
  }

  const localApi = axios.create(axiosConfig);

  /**
   * For any api calls, try to output a notification if we get an api error
   */
  localApi.interceptors.response.use(
    resp => resp,
    (error) => {
      const status = error.response ? error.response.status : 500;

      if (status <= 500) {
        // don't display if it's just a case of empty result set
        if (status === 404 && error.response.data.data.length === 0) {
          // show no message
        } else if (error.response && error.response.data.error) {
          store.dispatch('displayApiError', error.response.data.error.message);
        } else {
          // generic - show the message to give some sort of incling
          // TODO: In production we only want to show a generic message
          try {
            const message =
              process.env.NODE_ENV === 'development'
                ? `We encountered an issue.  Please try again<br />(${
                  error.response.data.errors[0].message
                })`
                : 'We encountered an issue.  Please try again';
            store.dispatch('displayApiError', message);
          } catch (err) {
            console.log(err);
          }
        }
      }

      return Promise.reject(error);
    },
  );
  return localApi;
};

export default api;
